var map = {
	"./365.svg": "ffcc",
	"./docu_sign.svg": "13a4",
	"./facebook.svg": "95e7",
	"./fitt.svg": "0e4e",
	"./hub_spot.png": "d7df",
	"./hub_spot.svg": "c154",
	"./mail_chimp.svg": "a469",
	"./maps.svg": "8cc1",
	"./monday.svg": "4f2a",
	"./oracle.svg": "d2eb",
	"./pay_pal.svg": "572f",
	"./power_bi.svg": "9b1e",
	"./sage.svg": "f3e1",
	"./sap.svg": "8c71",
	"./square.svg": "b2ab",
	"./survey_monkey.svg": "1370",
	"./tableau.svg": "8b97",
	"./teams.svg": "f3b8",
	"./twilio.svg": "9340",
	"./twitter.svg": "83dc",
	"./uber.svg": "d992",
	"./whats_app.svg": "8cda",
	"./xero.svg": "3c8c",
	"./zoom.svg": "c900"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb05";